/* Scroll-triggered images (snippets/velora-lazy-image.liquid). Loads img[data-vlazy] 300 px before it enters the screen. */
(() => {
  if (window.__veloraLazyImg) return;
  window.__veloraLazyImg = true;
  const swap = (img) => {
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    if (img.dataset.src) img.src = img.dataset.src;
    img.removeAttribute('data-vlazy');
  };
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          swap(entry.target);
        });
      }, { rootMargin: '300px 0px' })
    : null;
  const scan = (root) => {
    (root || document).querySelectorAll('img[data-vlazy]').forEach((img) => {
      if (img.__vlazyBound) return;
      img.__vlazyBound = true;
      io ? io.observe(img) : swap(img);
    });
  };
  scan();
  // Horizontal rows (home product row, card swipe): when a scroller moves, everything pending inside it is loaded.
  document.addEventListener('scroll', (event) => {
    const el = event.target;
    if (!el || el === document || !el.querySelectorAll) return;
    el.querySelectorAll('img[data-vlazy]').forEach((img) => { io && io.unobserve(img); swap(img); });
  }, { capture: true, passive: true });
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  // Cards rendered later (filters, sorting) are picked up too.
  let timer;
  new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(scan, 80); })
    .observe(document.body, { childList: true, subtree: true });
})();
